import { render } from "./MessagesMy.vue?vue&type=template&id=7fd239a4&scoped=true&ts=true"
import script from "./MessagesMy.vue?vue&type=script&lang=ts"
export * from "./MessagesMy.vue?vue&type=script&lang=ts"

import "./MessagesMy.vue?vue&type=style&index=0&id=7fd239a4&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd239a4"]])

export default __exports__